import { PlayerPlenaryPage } from '@hendrx/core/plenary/pages/PlayerPlenaryPage';
import { createFileRoute } from '@tanstack/react-router';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import {
  anyOf,
  requireAuthenticated,
  requirePlenaryCookie,
  requirePlenaryLobbyAccess
} from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/plenary/$learningObjectDraftId')({
  beforeLoad: createRouteGuard(anyOf(requireAuthenticated(), requirePlenaryCookie()), requirePlenaryLobbyAccess()),
  validateSearch: (search: Record<string, unknown>) => {
    return {
      mode: (search.mode as string | undefined) || undefined
    };
  },
  component: PlayerPlenaryPageComponent
});

function PlayerPlenaryPageComponent() {
  const { learningObjectDraftId } = Route.useParams();

  return <PlayerPlenaryPage plenaryDraftId={learningObjectDraftId} />;
}
